<template>
  <el-dialog
    title="调账"
    :visible.sync="accountAdjustmentFlag"
    :destroy-on-close="true"
    width="30%"
    top="70px"
    style="text-align: center"
  >
    <el-form
      ref="addRuleForm"
      :model="addForm"
      :rules="formRules"
      label-width="70px"
    >
      <el-form-item label="费用项" prop="feeItemName">
        <el-input v-model="addForm.feeItemName" disabled></el-input>
      </el-form-item>
      <el-form-item label="币种" prop="currency">
        <el-select
          v-model="addForm.currency"
          style="width: 100%"
          placeholder="请选择币种"
        >
          <el-option
            v-for="item in currencyList"
            :label="item.currencyName"
            :value="item.currencyValue"
            :key="item.currencyValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="金额" prop="amount">
        <el-input v-model="addForm.amount" type="number"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="addForm.remark" type="textarea"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit" :loading="addLoading"
          >确定</el-button
        >
        <el-button
          @click.native="accountAdjustmentFlag = false"
          :loading="addLoading"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  AddFeeDetail,
} from "@/api/costManagement/feeOrgDetailReport.js";
import { GetCurrencyServiceModelList } from "@/api/common/common.js";
export default {
  data() {
    return {
      addForm: {},
      accountAdjustmentFlag: false,
      addLoading: false,
      expensesList: [],
      currencyList: [],
      formRules: {
        feeItemName: [
          { required: true, message: "请输入费用项", trigger: "change" },
        ],
        currency: [
          { required: true, message: "请选择币种", trigger: "change" },
        ],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
      },
    };
  },
  methods: {
    showDalog(data) {
      let { feeItemName, feeItemID, currency } = data;
      this.addForm = {
        feeItemName,
        feeItemID,
        currency,
        BaseType: 2,
      };
      this.accountAdjustmentFlag = true;
    },
    onSubmit() {
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              AddFeeDetail(para).then((res) => {
                this.$refs["addRuleForm"].resetFields();
                this.addLoading = false;
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg || "操作成功",
                    type: "success",
                  });
                  this.accountAdjustmentFlag = false;
                  this.$emit("searchTable", "");
                } else {
                  this.$message({
                    message: res.data.msg || "操作失败",
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    getCurrencyList() {
      let para = {};
      GetCurrencyServiceModelList(para).then((res) => {
        this.currencyList = res.data.response;
      });
    },
  },
  mounted() {
    this.getCurrencyList();
  },
};
</script>

